import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GameManager from './components/GameManager';
import { ScoreCleanup } from './components/ScoreCleanup';
// Import the new pages
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import AboutUsPage from './components/AboutUsPage';
import ContactUsPage from './components/ContactUsPage';
// START OF EDITS: Import the new GamAdSlot component
import AdSenseSidebarAd from './components/AdSenseSidebarAd';
import AdSenseSidebarRightAd from './components/AdSenseSidebarRightAd';
import FooterAd from './components/FooterAd';
// END OF EDITS

function App() {
  return (
    <Router>
      <div className="App relative">

        {/* START OF EDITS: This now uses the new GamAdSlot component */}
        <div className="whichyr-raptive-sidebar hidden lg:block fixed top-1/2 left-4 transform -translate-y-1/2">
     
        </div>
        {/* END OF EDITS */}
        
        {/* Right sidebar ad */}
        <div className="whichyr-raptive-sidebar hidden lg:block fixed top-1/2 right-4 transform -translate-y-1/2">
       
        </div>
        <div className="h-[calc(100dvh-50px)] md:h-[calc(100dvh-90px)] mx-auto lg:px-[180px]">
          <div className="h-full">
            <Routes>
              <Route path="/challenge/:date" element={<GameManager />} />
              <Route path="/" element={<GameManager />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/about" element={<AboutUsPage />} />
              <Route path="/contact" element={<ContactUsPage />} />

              {/* Optional cleanup route */}
              <Route path="/cleanup" element={<ScoreCleanup />} />
            </Routes>
          </div>
        </div>
        {/*  Add the new FooterAd component here  */}
        <FooterAd />
    
      </div>
    </Router>
  );
}

export default App;
